<template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Modyfikuj wpłatę {{$n(payed, 'currency', 'pl-PL')}}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                          <v-row dense> 
                                    
                            <v-col cols="4">
                              <v-text-field 
                                v-model="stay" 
                                :error-messages="stayErrors" required 
                                @input="$v.stay.$touch()"  
                                persistent-hint
                                @blur="$v.stay.$touch()" label="Pobyt"></v-text-field>                            
                            </v-col>

                             <v-col cols="4">
                              <v-text-field 
                                v-model="meal" 
                                :error-messages="mealErrors" required 
                                @input="$v.meal.$touch()"  
                                persistent-hint
                                @blur="$v.meal.$touch()" label="Żywienie"></v-text-field>                            
                            </v-col>

                             <v-col cols="4">
                              <v-text-field 
                                v-model="other" 
                                :error-messages="otherErrors" required 
                                @input="$v.other.$touch()"  
                                persistent-hint
                                @blur="$v.other.$touch()" label="Inne"></v-text-field>                            
                            </v-col>
                           <v-col v-if="sumErrors" cols="12" class="d-flex flex-column align-center">
                              <v-alert dense outlined type="error">
                                   Suma czynników musi być równa kwocie wpłaty 
                              </v-alert>    
                            </v-col>
                          </v-row>
                        
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="close()">Anuluj</v-btn>
                      <v-btn color="primary darken-1" text @click="handleSubmit" >Zapisz</v-btn>
                    </v-card-actions>
                  </v-card>
</template>

<script>
  import required from 'vuelidate/lib/validators/required'
  import sameAs from 'vuelidate/lib/validators/sameAs'
  import { helpers } from 'vuelidate/lib/validators'
  const decimalPL = helpers.regex('decimalPL', /^[-]?\d*(\,\d+)?$/)

  export default {
    data: function () {
      return {
        stay: this.payedStay,
        meal: this.payedMeal,
        other: this.payedOther
      }
    },
    props:['payed','payedStay','payedMeal','payedOther'],
    validations: {
        stay:{
                required,
                decimalPL
            },
        meal:{
                required,
                decimalPL
            },
        other:{
                required,
                decimalPL
            },
        sum:{
          sameAsPayed:sameAs('payed')
        }
    },
    watch: {
        
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      sum(){
        if(this.stay == null) return 0
        else return parseFloat(this.stay.toString().replace(/\./g, "").replace(/,/, ".")) + parseFloat(this.meal.toString().replace(/\./g, "").replace(/,/, ".")) + parseFloat(this.other.toString().replace(/\./g, "").replace(/,/, "."));
      },
      stayErrors () {
        const errors = []
        if (!this.$v.stay.$dirty) return errors
        !this.$v.stay.required && errors.push('Kwota jest wymagana')
        !this.$v.stay.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      mealErrors () {
        const errors = []
        if (!this.$v.meal.$dirty) return errors
        !this.$v.meal.required && errors.push('Kwota jest wymagana')
        !this.$v.meal.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      otherErrors () {
        const errors = []
        if (!this.$v.other.$dirty) return errors
        !this.$v.other.required && errors.push('Kwota jest wymagana')
        !this.$v.other.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        return errors
      },
      sumErrors () {
        //if (!this.$v.sum.$dirty) return false
        if (!this.$v.sum.sameAsPayed) return true
        return false
      },
    },
 
    methods: {
      close(){
        this.$v.$reset();
        this.$emit('close');
      },
       handleSubmit () {
         this.$v.$touch()
         if (this.$v.$invalid) {

         } else {
                   this.$emit('amountChange',{
                     stay:parseFloat(this.stay.toString().replace(/\./g, "").replace(/,/, ".")),
                     meal:parseFloat(this.meal.toString().replace(/\./g, "").replace(/,/, ".")),
                     other:parseFloat(this.other.toString().replace(/\./g, "").replace(/,/, "."))});
                   this.$emit('close');
        //         this.$store.dispatch( 'generateSettlementsBO', {
        //           child_id:  this.childId,
        //           amount:  this.editedItem.amount.toString().replace(/\./g, "").replace(/,/, ".")
        //       });

         }
      },
    },
  }
</script>

